// extracted by mini-css-extract-plugin
export var brand = "_3g-9";
export var button = "_3g-0";
export var chevron = "_3g-v";
export var chevronButton = "_3g-w";
export var content = "_3g-n";
export var danger = "_3g-g";
export var dangerOutlined = "_3g-h";
export var dark = "_3g-l";
export var darkTheme = "_3g-c";
export var extraSmall = "_3g-4";
export var fullWidth = "_3g-8";
export var ghost = "_3g-d";
export var gray = "_3g-t";
export var icon = "_3g-p";
export var iconButton = "_3g-s";
export var iconButtonBorder = "_3g-x";
export var iconButtonBorderDark = "_3g-y";
export var iconButtonBorderLight = "_3g-z";
export var iconLeft = "_3g-q";
export var iconRight = "_3g-r";
export var large = "_3g-1";
export var light = "_3g-m";
export var medium = "_3g-2";
export var micro = "_3g-5";
export var nano = "_3g-7";
export var outlined = "_3g-k";
export var pending = "_3g-a";
export var primary = "_3g-i";
export var shadow = "_3g-o";
export var small = "_3g-3";
export var solidLight = "_3g-e";
export var solidLightBrand = "_3g-f";
export var spinner = "_3g-u";
export var transparent = "_3g-j";
export var warning = "_3g-b";
export var wideNano = "_3g-6";